import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { SiteContentItem } from '../app.component';
import { DialogService } from '../app.dialog-service';
import { TranslationService } from '../app.translation-service';

@Component({
	selector: 'app-cube-contents',
	templateUrl: './cube-contents.component.html',
	styleUrls: ['./cube-contents.component.less']
})
export class CubeContentsComponent implements OnChanges {

	/**
	 * Content to display
	 */
	@Input()
	public content?: SiteContentItem | null;

	/**
	 * The content that is opened
	 */
	public contentOpened?: SiteContentItem | null;

	/**
	 * If content is displayed
	 */
	public contentDisplay = false;

	/**
	 * Constructor
	 */
	constructor(public i18n: TranslationService, public dialog: DialogService) {
	}

	/**
	 * Open sub-content
	 */
	public openSubContent(item?: SiteContentItem | null): void {
		this.contentOpened = item;
	}

	/**
	 * Open more info popup
	 */
	public openMoreInfoPopup(event: MouseEvent): void {
		this.dialog.openPopup({
			text: this.i18n._.MORE_INFO,
			x: event.clientX,
			y: event.clientY - 100,
			tooltip: true
		});
	}

	/**
	 * Close more info popup
	 */
	public closeMoreInfoPopup(): void {
		this.dialog.closePopup();
	}

	/**
	 * On changes
	 */
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.content) {
			if (this.content != null) {
				if (this.contentDisplay) {
					this.contentDisplay = false;
					setTimeout(() => {
						this.contentDisplay = true;
					}, 1400);
				} else {
					setTimeout(() => {
						this.contentDisplay = true;
					}, 400);
				}
			} else {
				this.contentDisplay = false;
			}
			this.contentOpened = null;
		}
	}
}
